import { getWebsiteUrl } from '@va/dashboard/selectors/core';
import { getUrlWithoutProtocolAndTrailingSlash } from '@va/util/helpers';
import moment, { Moment } from 'moment';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useCurrentPeriodFilter } from './useCurrentPeriodFilter';

export const useVerboseFilename = () => {
  const websiteUrl = useSelector(getWebsiteUrl);
  const { from, until } = useCurrentPeriodFilter();
  const createVerboseFilename = useCallback(
    ({ fileName, extension }: { extension?: string; fileName: string }) => {
      let fName = `${getUrlWithoutProtocolAndTrailingSlash(websiteUrl)}_${formatDate(from)}_${formatDate(
        until,
      )}_${fileName}`;

      if (extension) {
        fName += `.${extension}`;
      }
      return fName;
    },
    [from, until, websiteUrl],
  );

  return { createVerboseFilename };
};

function formatDate(date: string | Moment) {
  return moment(date).format('YYYY-MM-DD');
}
